/* eslint-disable react-hooks/exhaustive-deps */
import {  useState } from "react";
import { useFetch } from "../hooks/useFetch";
import { createPlanByAdmin, getAllPlanByAdmin, updatePlanByAdmin } from "../api/planApi";
import "./css/Plans.css";
import AccessControl from "../components/AccessControl";

const EMPTY = { name: "SILVER", value: 1, unit: "months", amount: 0, isActive: true };

export default function PlansPage() {

  const { data, loading, error, refetch } = useFetch(getAllPlanByAdmin);

  const [modal,  setModal]  = useState(false);
  const [form,   setForm]   = useState(EMPTY);
  const [editId, setEditId] = useState(null);
  const [busy,   setBusy]   = useState(false);
  const [toast,  setToast]  = useState("");

  /* FIX: Safely extract the array from API response */
  const rows = Array.isArray(data)
    ? data
    : data?.plans ?? data?.data ?? [];

  const openCreate = () => { setForm(EMPTY); setEditId(null); setModal(true); };
  const openEdit   = (plan) => {
    setForm({
      name:     plan.name,
      value:    plan.value,
      unit:     plan.unit,
      amount:   plan.amount,
      isActive: plan.isActive,
    });
    setEditId(plan._id);
    setModal(true);
  };

  const handleSave = async () => {
    setBusy(true);
    try {
      if (editId) {
        await updatePlanByAdmin(editId, form);
        setToast("✅ Plan updated");
      } else {
        await createPlanByAdmin(form);
        setToast("✅ Plan created");
      }
      setModal(false);
      refetch();
    } catch (e) {
      setToast(`❌ ${e?.message || "Something went wrong"}`);
    } finally {
      setBusy(false);
      setTimeout(() => setToast(""), 3000);
    }
  };

  const set = (key, val) => setForm((f) => ({ ...f, [key]: val }));

  const planOrder = ["TRAIL", "SILVER", "GOLD", "PLATINUM"];
  const sorted    = [...rows].sort(
    (a, b) => planOrder.indexOf(a.name) - planOrder.indexOf(b.name)
  );

  const getCardClass = (name) => {
    const map = { TRAIL: "trail", SILVER: "silver", GOLD: "gold", PLATINUM: "platinum" };
    return map[name] || "";
  };

  return (
    <div className="plans-container">
<AccessControl
        allowedRoles={["SUPERADMIN", "ADMIN","HR", "NSM", "RSM", "ASM", "TSO"]}
        redirectTo="/404"
      />
      {/* Header */}
      <div className="plans-header">
        <div>
          <h1 style={{ margin: 0, fontSize: "22px", color: "#1f2937" }}>Plan Managements</h1>
          <p style={{ margin: "4px 0 0", fontSize: "14px", color: "#6b7280" }}>
            Manage subscription plans
          </p>
        </div>

        <button className="btn btn-success" onClick={openCreate}>
          + New Plan
        </button>
      </div>

      {/* Toast */}
      {toast && <div className="toast-bar">{toast}</div>}

      {/* Loading */}
      {loading ? (
        <div className="skeleton-table">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="skeleton-row" style={{ height: 100 }} />
          ))}
        </div>
      ) : error ? (
        <p className="error-text">{error}</p>
      ) : sorted.length === 0 ? (
        <div className="empty-state">
          <p className="empty-icon">📋</p>
          <p className="empty-title">No plans found</p>
          <p className="empty-sub">Create your first plan to get started</p>
        </div>
      ) : (
        <div className="plans-grid">
          {sorted.map((plan) => (
            <div key={plan._id} className={`plan-card ${getCardClass(plan.name)}`}>
              {!plan.isActive && <span className="inactive-badge">Inactive</span>}
              <span className="plan-name">{plan.name}</span>
              <p className="plan-amount">₹{plan.amount?.toLocaleString()}</p>
              <p className="plan-duration">{plan.value} {plan.unit}</p>
              <button className="btn-edit" onClick={() => openEdit(plan)}>
                Edit
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Create / Edit Modal */}
      {modal && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{editId ? "Edit Plan" : "Create Plan"}</h3>
              <button
                className="modal-close"
                onClick={() => setModal(false)}
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Plan Name</label>
                <select
                  value={form.name}
                  onChange={(e) => set("name", e.target.value)}
                  disabled={!!editId}
                >
                  {["TRAIL", "SILVER", "GOLD", "PLATINUM"].map((n) => (
                    <option key={n} value={n}>{n}</option>
                  ))}
                </select>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Duration</label>
                  <input
                    type="number"
                    min={1}
                    value={form.value}
                    onChange={(e) => set("value", Number(e.target.value))}
                  />
                </div>
                <div className="form-group">
                  <label>Unit</label>
                  <select
                    value={form.unit}
                    onChange={(e) => set("unit", e.target.value)}
                  >
                    <option value="days">Days</option>
                    <option value="months">Months</option>
                    <option value="years">Years</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Amount (₹)</label>
                <input
                  type="number"
                  min={0}
                  value={form.amount}
                  onChange={(e) => set("amount", Number(e.target.value))}
                />
              </div>

              <label className="checkbox-group">
                <input
                  type="checkbox"
                  checked={form.isActive}
                  onChange={(e) => set("isActive", e.target.checked)}
                />
                <span>Active (visible to drivers)</span>
              </label>
            </div>

            <div className="modal-actions">
              <button className="btn-outline-green" onClick={() => setModal(false)}>
                Cancel
              </button>
              <button
                className="btn btn-success"
                onClick={handleSave}
                disabled={busy}
              >
                {busy ? "Saving…" : editId ? "Update Plan" : "Create Plan"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}